module.exports = __webpack_public_path__ + "static/meda-provider8-4360ffe3fd068a200c52a8875a7d4b8c.png";